import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import get from 'lodash.get';
import tracking from 'dibs-tracking';
import { cartItemRemoveMutation } from './mutations/cartItemRemoveMutation';
import { removeLocalCartItem } from './actions/localCartActions';
import { removePortfolioCartItem } from './actions/portfolioCartActions';

// components
import CartItem from './item/CartItem';

function CartItems(props) {
    const { portfolioItems, localItems, user, viewer, relay, dispatch } = props;

    const cartItems = user ? get(portfolioItems, 'edges', []) : get(localItems, 'edges', []);

    return (
        <div>
            {cartItems.map((edge, index) => {
                const node = get(edge, 'node');
                if (!node) {
                    return null;
                }

                const trackingParams = get(node, 'item.ecommerceTrackingParams');
                const item = user ? node.item : node;

                return (
                    <CartItem
                        key={item.serviceId}
                        user={user}
                        viewer={viewer}
                        item={item}
                        onRemoveItem={() => {
                            if (user) {
                                cartItemRemoveMutation(relay.environment, {
                                    viewerId: viewer.id,
                                    userId: user.serviceId,
                                    portfolioId: node.portfolioId,
                                    portfolioItemId: node.portfolioItemId,
                                    portfolioItemRelayId: node.id,
                                }).then(() =>
                                    dispatch(removePortfolioCartItem(node.portfolioItemId))
                                );
                            } else {
                                dispatch(removeLocalCartItem(item.serviceId));
                            }
                        }}
                        onClickProduct={() => {
                            if (trackingParams) {
                                tracking.trackEcommerce({
                                    type: 'productClick',
                                    actionField: {
                                        list: 'cart',
                                    },
                                    products: [
                                        {
                                            ...trackingParams,
                                            position: index,
                                        },
                                    ],
                                });
                            }
                        }}
                    />
                );
            })}
        </div>
    );
}

CartItems.propTypes = {
    relay: PropTypes.object.isRequired,
    portfolioItems: PropTypes.object,
    localItems: PropTypes.object,
    user: PropTypes.object,
    viewer: PropTypes.object,
    // redux
    dispatch: PropTypes.func.isRequired,
};

export default createFragmentContainer(connect()(CartItems), {
    viewer: graphql`
        fragment CartItems_viewer on Viewer {
            ...CartItem_viewer
            id
        }
    `,
    user: graphql`
        fragment CartItems_user on User {
            ...CartItem_user
            serviceId
        }
    `,
    portfolioItems: graphql`
        fragment CartItems_portfolioItems on PortfolioItemsConnection
            @argumentDefinitions(loadPortfolioData: { type: "Boolean!", defaultValue: true }) {
            edges {
                node {
                    id
                    portfolioId
                    portfolioItemId
                    item {
                        ...CartItem_item
                        ecommerceTrackingParams
                        serviceId
                    }
                }
            }
        }
    `,
    localItems: graphql`
        fragment CartItems_localItems on ItemsConnection {
            edges {
                node {
                    id
                    serviceId
                    ...CartItem_item
                }
            }
        }
    `,
});
